/*
 * Copyright 2025 Intuition Robotics ltd
 */
import __asset_0 from "@res/icons/btn_radio.svg";
import __asset_1 from "@res/icons/btn_radio_checked.svg";
import * as React from "react";

type Props = {
	on: boolean
	onChange: (newState: boolean) => void
}

const off = __asset_0;
const on = __asset_1;

export class RadioButton
	extends React.Component<Props> {

	render() {
		const isOn = this.props.on;
		return <img onClick={() => this.props.onChange && this.props.onChange(!this.props.on)} src={isOn ? on : off} alt="on"/>;
	}

}
